import angular from 'angular';
import template from './template.jade';
import './styles.styl';

export default angular
	.module('ui.cian.checkbox', [])
	.directive('cianUiCheckboxWrapper', () => ({
		scope: true,
		bindToController: {
			type: '@?',
			cuiRequired: '=',
			cuiInvalid: '=',
			cuiDisabled: '=',
			cuiCheckboxTooltip: '=',
			cuiCheckboxTooltipOpen: '=',
			cuiCheckboxTooltipPlacement: '@',
			cuiCheckboxTooltipClass: '@'
		},
		controller() {},
		link($scope, $element) {
			const ctrl = $scope.checkbox;
			const $input = $element.find('input');
			$input.bind('click', () => $scope.$apply());
			ctrl.isChecked = () => {
				return $input[0].checked;
			};
		},
		controllerAs: 'checkbox',
		transclude: true,
		replace: true,
		template
	}))
	.name;



// WEBPACK FOOTER //
// ./~/@cian/ui/app/components/checkbox-wrapper/index.jsm